/**
 * A preset is a template with no organization — `tournamentId === null`.
 */
export function isPresetTemplate(template: { tournamentId: number | null }): boolean {
  return template.tournamentId === null;
}
